import React, { Component } from "react";
import { Button, Modal } from "antd";
import Table from "./Table";
/*
const error = function() {
	Modal.error({
		visible: false,
		title: 'This is an error message',
		content: 'some messages...some messages...'
	});
};
*/
class ixModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      translations: this.props.translations || {}
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ translations: nextProps.translations });
  }

  render() {
    const { translations } = this.state;
    return (
      <Modal
        className="upload-modal"
        width={768}
        title={this.props.modalTitle}
        visible={this.props.visible}
        cancelText={translations ? translations.cancel : "Cancel"}
        onOk={this.props.onOk}
        onCancel={this.props.onCancel}
        closable={false}
        footer={[
          <Button key="delete" className="d-none" onClick={this.props.onDelete}>
            Remove selected
          </Button>,
          <Button
            data-translationkey="return"
            key="back"
            onClick={this.props.onReturn}
          >
            {translations ? translations.return : "Return"}
          </Button>,
          <Button
            data-translationkey="submit"
            id="submitPreflight"
            key="submit"
            type="primary"
            onClick={this.props.onOk}
          >
            {translations ? translations.submit : "Submit"}
          </Button>
        ]}
      >
        <Table
          selectedRowKeys={this.props.selectedRowKeys}
          pagination={false}
          tableData={this.props.tableData}
          columns={this.props.columns}
          scroll={{ y: 240 }}
        />
        <p>{this.props.text}</p>
      </Modal>
    );
  }
}

export default ixModal;



// WEBPACK FOOTER //
// ./src/components/Modal.js